module.exports = __webpack_public_path__ + "img/bannerGreen.befd391f.jpg";